import com from '@/api/common.js'; //工具
import tools from '@/api/tools.js'; //工具
export const loading = {
  data() {
    return {
      loading: false
    };
  },
  watch: {
    loading(val) {
      try {
        this.$root.$children[0].loading = val;
      } catch (e) {
        console.log('loading写入异常');
      }
    }
  }
};
export const share = {
  methods: {
    // convert是否需要转换短链接
    // type=1 ok保活动页面专用短链接
    openSharePanel(shareData, convert, type) {
      if (convert) {
        const params = {
          url: encodeURIComponent(shareData.link)
        };
        if (this.$tools.isOKbao()) {
          params.type = type;
        }
        this.$http({
          type: 'PUT',
          url: '/api/tools/transformLongUrl',
          data: params
        }).then(res => {
          shareData.link = res.data;
          this.$app.openSharePanel(shareData);
        });
      } else {
        this.$app.openSharePanel(shareData);
      }
    },
    // convert是否需要转换短链接
    shareInit(shareData, convert) {
      console.log('com.isApp', com.isApp);
      if (com.isApp) {
        if (convert) {
          this.$http({
            type: 'PUT',
            url: '/api/tools/transformLongUrl',
            data: {
              url: encodeURIComponent(shareData.link)
            }
          }).then(res => {
            shareData.link = res.data;
            this.$app.initShare(shareData);
          });
        } else {
          this.$app.initShare(shareData);
        }
      } else {
        this.$weixin.share(shareData);
      }
    }
  }
};
export const common = {
  mixins: [share],
  data() {
    return {
      loading: false,
      wxInfo: {},
      all: {
        POLICY_STATUS: {}
      } //字典数据
    };
  },
  watch: {
    loading(val) {
      try {
        this.$root.$children[0].loading = val;
      } catch (e) {
        console.log('loading写入异常');
      }
    }
  },
  methods: {
    transformLongUrl(url) {
      return this.$http({
        type: 'PUT',
        url: '/api/tools/transformLongUrl',
        data: {
          url: encodeURIComponent(url)
        }
      }).then(res => {
        return res.data;
      });
    },
    checkLogin() {
      // token不存在跳转登录
      if (!localStorage.jzy_token) {
        tools.outLogin();
        return false;
      }
      return true;
    },
    setUser(data) {
      const user = this.getUser();
      Object.assign(user, data);
      localStorage.jzy_user = JSON.stringify(user);
    },
    getUser() {
      try {
        const user = JSON.parse(localStorage.jzy_user);
        return user;
      } catch (error) {
        return {};
      }
    },
    openFile(params) {
      const fileType = params.url
        ? params.url
            .split('.')
            .pop()
            .toLowerCase()
        : '';
      let query = {};
      if (com.isApp) {
        if (fileType == 'pdf') {
          if (params.apiPermissionCode) {
            if (params.url.indexOf('?') != -1) {
              params.url += '&apiPermissionCode=' + params.apiPermissionCode;
            } else {
              params.url += '?apiPermissionCode=' + params.apiPermissionCode;
            }
          }
          this.$app.readPdf({
            url: params.url,
            title: params.title
          });
        } else if (['jpg', 'jpeg', 'png'].includes(fileType)) {
          this.$app.readImg({
            arr: [params.url],
            index: 0,
            share: true,
            title: params.title
          });
        } else if (['xls', 'xlsx'].includes(fileType)) {
          //原生处理不了Excel 前端自行掉接口
          // if (params.apiPermissionCode) {
          //   this.$tools.getHealthTest(params.apiPermissionCode);
          // }
          if (params.apiPermissionCode) {
            if (params.url.indexOf('?') != -1) {
              params.url += '&apiPermissionCode=' + params.apiPermissionCode;
            } else {
              params.url += '?apiPermissionCode=' + params.apiPermissionCode;
            }
          }
          this.$app.readExcel({
            url: params.url,
            title: params.title
          });
        } else {
          this.$notice.msg('文件格式不支持预览');
        }
        return;
      } else if (params.url) {
        if (this.$tools.isWeiXin()) {
          query = { url: params.url };
        } else {
          location.href = params.url;
          return;
        }
      } else if (params.id) {
        // params.id 文章id
        query = { id: params.id, index: params.index || 0 };
      } else if (params.fileId) {
        query = { fileId: params.fileId };
      } else {
        this.$notice.msg('文件不存在');
        return;
      }
      this.$router.push({
        path: '/apps/newMaterial/downloadFile',
        query
      });
    },
    goPage(url, params) {
      this.$router.push({
        path: url,
        query: params
      });
    },
    jumpPage(url, inside, params) {
      if (inside) {
        this.goPage(url, params);
      } else {
        location.href = url;
      }
    },
    // 登录成功 绑定微信数据 需要token
    bindWxData() {
      if (!localStorage.wechatId) {
        return;
      }
      const userinfo = JSON.parse(localStorage.jzy_user);
      return this.$http({
        type: 'POST',
        url: '/api/we/associate',
        hideAlert: true,
        data: {
          wechatId: localStorage.wechatId,
          userId: userinfo.userId,
        }
      });
    },
    async transferPage() {
      await this.bindWxData();
      let url = '/apps/index';
      if (this.$route.query.goPage == 1) {
        //计划书
        const userinfo = JSON.parse(localStorage.jzy_user);
        let url = '/api/productBase/getPlanUrl';
        const params = { userId: userinfo.userId };
        if (this.$route.query.type == 'detail') {
          url = '/api/productBase/getPlanUrlDetail';
          params.insureUniqueId = this.$route.query.insureUniqueId;
          params.productCode = this.$route.query.productCode;
          params.gradeCode = this.$route.query.gradeCode;
        } else if (this.$route.query.type == 'compare') {
          url = '/api/productBase/getCompareUrl';
        }
        if (this.$route.query.tab) {
          params.tab = this.$route.query.tab;
        }
        if (this.$route.query.hideTab) {
          params.hideTab = this.$route.query.hideTab;
        }
        this.goOutsidePage(url, params);
        return;
      } else if (this.$route.query.goPage == 2) {
        //保单托管
        const userinfo = JSON.parse(localStorage.jzy_user);
        url = '/policydeposit/policySteward?source=MGA&code=$userId$'.replace('$userId$', userinfo.userId);
      } else if (this.$route.query.goPage == 3) {
        //微店
        const userinfo = JSON.parse(localStorage.jzy_user);
        url = this.$config.productBase + '/c/#/?userId=$userId$'.replace('$userId$', userinfo.userId);
      } else if (this.$route.query.goPage == 4) {
        //投保工具
        const userinfo = JSON.parse(localStorage.jzy_user);
        let url = '/api/productBase/getSign';
        const params = { userId: userinfo.userId };
        this.goOutsidePage(url, params);
        return;
      } else if (this.$route.query.goPage) {
        url = this.$route.query.goPage;
      } else if (sessionStorage.jzyLoginPage && !sessionStorage.jzyLoginPage.includes('login')) {
        url = sessionStorage.jzyLoginPage;
      }
      console.log('transferPage', url);
      location.replace(url);
    },
    // 跳转外部页面获取授权地址
    goOutsidePage(url, params) {
      this.$http({
        type: 'GET',
        url: url,
        hideAlert: true,
        data: params
      }).then(async res => {
        if (res.httpCode == 401) {
          this.loading = false;
          const userInfo = JSON.parse(localStorage.getItem('jzy_user'));
          const topOrgId = await this.getTopId(userInfo.orgId);
          window.setTimeout(() => {
            this.$router.replace({
              path: '/apps/sign/leaflet',
              query: {
                orgId: topOrgId
              }
            });
          }, 1);
        } else if (res.httpCode == 40400 || res.httpCode == 40408) {
          this.goLogin();
        } else if (res.httpCode == 1 && res.data) {
          location.replace(res.data);
        }
      });
    },
    // 获取商户机构id
    getTopId(orgId) {
      return this.$http({
        url: '/api/userAuth/queryOrgIdBySub',
        type: 'GET',
        data: {
          subOrgId: orgId
        }
      }).then(res => {
        return res.data;
      });
    },
    goLogin() {
      // 已在登录页不处理
      if (['login', 'loginByCode', 'loginByCodeTbLogin', 'insteadTbLogin'].includes(this.$route.name)) {
        return;
      }
      this.loading = false;
      setTimeout(_ => {
        this.$router.replace({
          path: '/apps/login',
          query: {
            ...this.$route.query,
            noAutoLogin: 1
          }
        });
      }, 1);
    },
    goProductDeatil(code, info) {
      if (info && info.status) {
        if (info.lastNum > 0) {
          const userId = this.getUser().userId;
          location.href = `/m/product/app/${userId}/${code}`;
        } else {
          this.$notice.msg('您的赠险份数不足');
        }
      } else if (info && info.sourceType == 2) {
        //线下产品
        if (info.insureUrl) {
          location.href = info.insureUrl;
        }
      } else {
        const userId = this.getUser().userId;
        location.href = `/m/product/app/${userId}/${code}`;
      }
    },
    //根据type类型获取字典
    getDicByType(params = {}) {
      return new Promise((resolved, rejected) => {
        let jzy_allData = sessionStorage.jzy_allData;
        if (jzy_allData && JSON.parse(jzy_allData)[params.type]) {
          resolved(JSON.parse(jzy_allData)[params.type]);
        } else {
          this.$http({
            url: '/api/dic/read/all',
            type: 'GET'
          }).then(resData => {
            sessionStorage.jzy_allData = JSON.stringify(resData.data);
            resolved(resData.data[params.type]);
          });
        }
      });
    },
    setAllData() {
      return new Promise((resolved, rejected) => {
        if (sessionStorage.jzy_allData) {
          try {
            this.all = JSON.parse(sessionStorage.jzy_allData);
            resolved();
            return;
          } catch (error) {
            rejected();
            console.log('ALL数据解析异常');
          }
        }
        this.$http({
          url: '/api/dic/read/all',
          type: 'GET'
        }).then(resData => {
          this.all = resData.data;
          sessionStorage.jzy_allData = JSON.stringify(resData.data);
          resolved();
        });
      });
    },
    //校验密码
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.msg('密码长度8-16位，包含数字、大写字母、小写字母、符号中的至少3种'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    descrypt(params, bean, key, apiPermissionCode = '') {
      return this.$http({
        type: 'POST',
        url: '/app/permissionLog/descrypt',
        data: params,
        apiPermissionCode
      }).then(res => {
        this.$set(bean, key, res.data.data);
      });
    }
  }
};
export const pageTools = {
  data() {
    return {
      requestType: 'POST',
      pageNum: 1,
      pageSize: 20,
      list: [],
      reqArr: [],
      listUrl: '',
      listCount: 0,
      listLoading: true, // 初始化置true，避免重复触发
      finished: false, //是否加载完成
      finishedText: '暂无更多数据',
      timer: {}
    };
  },
  methods: {
    setRequestType(type) {
      this.requestType = type;
    },
    initListAjax(url) {
      this.listUrl = url;
      this.getListHttp();
    },
    // 搜索
    searchAjax(url) {
      if (url) {
        this.listUrl = url;
      }
      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      this.pageNum = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getListHttp();
      }, 500);
    },
    // 设置自定义参数
    setListParams(params) {},
    //请求回调
    listCallback() {},
    nextPage() {
      if (this.listUrl) {
        this.pageNum++;
        this.getListHttp();
      }
    },
    // ajax请求
    getListHttp() {
      const params = {
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.listLoading = true;
      if (!this.listUrl) {
        return;
      }
      this.$http({
        type: this.requestType,
        url: this.listUrl,
        data: params
      })
        .then(resData => {
          this.listLoading = false;
          if (resData.data && resData.data.length > 0) {
            resData.data.forEach(item => {
              this.$set(item, 'isList', true);
            });
          }
          const list = resData.data;
          this.listCount = resData.total;
          if (this.pageNum > 1) {
            this.list = this.list.concat(list);
          } else {
            this.list = list;
          }
          if (this.list.length < resData.total) {
            this.finished = false;
            this.finishedText = '';
          } else {
            this.finished = true;
            this.finishedText = '暂无更多数据';
          }
          if (this.list.length == 0) {
            this.finished = true;
            this.finishedText = '';
          }
          this.listCallback(resData);
        })
        .catch(e => {
          console.log(e);
          this.finished = true;
          this.finishedText = e.msg || '系统异常';
        });
    }
  }
};

export const pageRes = {
  data() {
    return {
      requestType: 'PUT',
      pageNum: 1,
      pageSize: 20,
      list: [],
      listUrl: '',
      listCount: 0,
      listLoading: false,
      finished: false, //是否加载完成
      finishedText: '暂无更多数据',
      timer: {}
    };
  },
  methods: {
    setRequestType(type) {
      this.requestType = type;
    },
    initListAjax(url) {
      this.listUrl = url;
      this.getListHttp();
    },
    // 搜索
    searchAjax(url) {
      if (url) {
        this.listUrl = url;
      }
      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      this.pageNum = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getListHttp();
      }, 500);
    },
    // 设置自定义参数
    setListParams(params) {},
    //请求回调
    listCallback() {},
    nextPage() {
      if (this.listUrl) {
        this.pageNum++;
        this.getListHttp();
      }
    },
    // ajax请求
    getListHttp() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.listLoading = true;
      this.$http({
        type: this.requestType,
        url: this.listUrl,
        data: params
      }).then(resData => {
        this.listLoading = false;
        this.listCount = resData.data.data.total;
        const list = resData.data.data.records;
        if (params.pageNum > 1) {
          this.list = this.list.concat(list);
        } else {
          this.list = list;
        }
        if (this.list.length < resData.data.data.total) {
          this.finished = false;
          this.finishedText = '';
        } else {
          this.finished = true;
          this.finishedText = '暂无更多数据';
        }
        if (this.list.length == 0) {
          this.finished = true;
          this.finishedText = '';
        }
        this.listCallback(resData.data.data, resData);
      });
    }
  }
};
// 验证码倒计时
const CODE_SIZE = 60;
export const codeTools = {
  data() {
    return {
      CODE_SIZE,
      codeIndex: CODE_SIZE,
      timer: {}
    };
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  methods: {
    timerStart() {
      if (this.codeIndex != CODE_SIZE) {
        return;
      }
      window.clearInterval(this.timer);
      this.codeIndex--;
      this.timer = window.setInterval(() => {
        this.codeIndex--;
        console.log(this.codeIndex);
        if (this.codeIndex <= 0) {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
          return;
        }
      }, 1000);
    },
    getCodeAjax(mobile) {
      if (!this.$regulars.isPhone(mobile)) {
        this.$notice.msg('请输入正确的手机号');
        return;
      }
      this.timerStart();
      this.$http({
        type: 'GET',
        url: '/api/user/sendCode',
        data: {
          mobile
        }
      })
        .then(res => {})
        .catch(e => {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
        });
    }
  }
};

export const loadData = {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      list: [],
      listUrl: '',
      listCount: 0,
      listLoading: false,
      finished: false, //是否加载完成
      finishedText: '',
      timer: {}
    };
  },
  methods: {
    initLoad(url) {
      this.listUrl = url;
      this.pageNum = 1;
      this.loadList();
    },
    resetList() {
      this.pageNum = 1;
      this.list = [];
      this.finished = true;
      this.listLoading = false;
    },
    // 搜索
    search() {
      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      this.pageNum = 1;
      this.list = [];
      let that = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        that.loadList();
      }, 500);
    },
    // 设置自定义参数
    setListParams(params) {},
    //请求回调
    listCallback() {},
    loadPage() {
      if (this.listUrl) {
        this.pageNum++;
        this.loadList();
      }
    },
    loadList() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.finished = false;
      this.listLoading = true;
      this.$http({
        type: 'PUT',
        url: this.listUrl,
        data: params
      }).then(res => {
        this.listLoading = false;
        this.listCount = res.total;
        const list = res.data;
        if (params.pageNum > 1) {
          this.list = this.list.concat(list);
        } else {
          this.list = list;
        }
        if (this.list.length < res.total) {
          this.finished = false;
          this.finishedText = '';
        } else if (this.list.length >= res.total && this.list.length != 0) {
          this.finished = true;
          this.finishedText = '暂无更多数据';
        } else if (this.list.length == 0) {
          this.finished = true;
          this.finishedText = '';
        }
        this.listCallback(res.data);
      });
    }
  }
};
